import { boolean, object, string } from "yup";

export const schema = object({
  sendEmailToProspect: boolean(),
  emailComments: string()
    .trim()
    .test(
      "is required",
      "Comment required to send email notification",
      function isPresentWhenRequired(value) {
        return this.parent.sendEmailToProspect ? !!value : true;
      },
    ),
  internalComments: string().trim(),
});
